import { Text } from '@medly-components/core';
import { lineClampStyle } from 'components/common/Styled';
import styled from 'styled-components';

export const ResourceWrapper = styled.div`
    display: inline-block;
`;

export const Resource = styled.div`
    margin-right: 2.4rem;
    cursor: pointer;
`;

export const ResourceImgContainer = styled.div`
    width: 22.4rem;
    height: 22.4rem;
    display: flex;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.colors.grey[300]};
    border-radius: 0.8rem;
    box-sizing: border-box;
    overflow: hidden;
    justify-content: center;

    img {
        min-width: 40%;
        max-width: 100%;
    }
`;

export const ResourceText = styled(Text)`
    width: 22.4rem;
    margin: 1.6rem 0;
    height: 4.4rem;
    ${lineClampStyle(2)}
`;
